<script>
import Topbar from "@/components/Topbar";
import { defineComponent } from "vue";
export default defineComponent({
  name: "layout",
  components: {
    Topbar,
  },
});
</script>
<template>
  <!-- Begin page -->
  <div id="layout-wrapper">
    <Topbar />
    <div class="container" id="main-container">
      <slot />
      <!-- End Page-content -->
    </div>
    <!-- end main content-->
  </div>
</template>
